type Header = {
  key: string;
  sortable?: boolean;
  label: string;
  class?: string;
  position?: number;
}

export const COLUMN_CLASS = 'bg-payroll text-uppercase'
export const COLUMN_CLASS2 = 'bg-payroll text-uppercase sticky-column'
export const COLUMN_CLASS3 = 'bg-payroll text-uppercase sticky-column2'
export const MAIN_HEADERS: Header[] = [
  {
    key: 'index',
    sortable: false,
    label: 'Nº',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.assignment.headquarter.name',
    sortable: false,
    label: 'Sede',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'condition',
    sortable: false,
    label: 'Condición',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'workCategory',
    sortable: false,
    label: 'Categoría Ocupacional',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'workType',
    sortable: false,
    label: 'Tipo de trabajo',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.assignment.area.name',
    sortable: false,
    label: 'Área',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.assignment.position.name',
    sortable: false,
    label: 'Cargo',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.assignment.sub_area.name',
    sortable: false,
    label: 'Función que realiza',
    class: 'one-line text-uppercase bg-yellow sticky-column',
    position: 1
  },
  {
    key: 'employee.insurance.cussp',
    sortable: false,
    label: 'CUSSP',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.document_number',
    sortable: false,
    label: 'Nº Documento',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.fullLastName',
    sortable: false,
    label: 'Apellidos',
    class: COLUMN_CLASS2,
    position: 1
  },
  {
    key: 'employee.name',
    sortable: false,
    label: 'Nombres',
    class: COLUMN_CLASS3,
    position: 1
  },
  {
    key: 'employee.status_text',
    sortable: false,
    label: 'Activo/Baja',
    class: COLUMN_CLASS,
    position: 1
  },
  {
    key: 'onp_spp',
    sortable: false,
    label: 'ONP/SPP',
    class: COLUMN_CLASS,
    position: 1
  },
  {
    key: 'workedDays',
    sortable: false,
    label: 'DIAS LAB/NO LAB/SUBSID Y NO SUBSID',
    class: COLUMN_CLASS,
    position: 1
  },
  {
    key: 'subsidiados',
    sortable: false,
    label: 'INCAP. TEMP (SUBSIDIO)',
    class: COLUMN_CLASS,
    position: 1
  },
  {
    key: 'singoce',
    sortable: false,
    label: 'licencia sin Goce',
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'absence',
    label: 'Falta',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'suspension',
    label: 'Suspención',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'ordinaryHours',
    label: 'Horas Ordinarios',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'ordinaryMinutes',
    label: 'Minutos Ordinarios',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'hourExtra25_35',
    label: 'HORAS._EXT. 25%-35%',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'minutesExtra',
    label: 'Minutos Sobretiempos',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'dobles',
    label: 'Horas Dobles',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'employee.finance.base_salary',
    label: 'Rem. Básica',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'jornaleBasic',
    label: 'Rem. Jornal Básico',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'pieceworkBasic',
    label: 'Remuneracion Destajo',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'family_allowance',
    label: 'Asig. Familiar',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'refreshment',
    label: 'Alimentacion Refrigerio',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'total_extra_25',
    label: 'Horas_extras al_25%',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'total_extra_35',
    label: 'Horas_extras al_35%',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'feriado_descanso',
    label: 'Importe Feriados/Horas Dobles',
    sortable: false,
    class: COLUMN_CLASS,
    position: 2
  },
  {
    key: 'importe_domingos',
    label: 'Dominical',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'loan_total',
    label: 'Feriados',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'feriadomayo',
    label: 'Feriado 1ero de Mayo',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'rem_vacacional',
    label: 'REM. VACACIONAL',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'importes_goce',
    label: 'Licencia Con Goce / Otro motivo',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'incapacidadtemporal',
    label: 'INCAPACIDAD TEMPORAL (Subsidio)',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'maternidad',
    label: 'SUBSIDIO MATERNIDAD',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'vacations_d',
    label: 'LIQUID./ VACAC. DEVENGADAS',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'vacations_t',
    label: 'LIQUID./ VACAC. TRUNCAS',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'utilidades',
    label: 'UTILIDADES',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'fiestas_patrias',
    label: 'Gratificaciones De Fiestas Patrias Y Navidad – Ley 29351',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'gp_ley_29351',
    label: 'Gratificaciones Proporcional – Ley  (LBS)',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'bet_ley_29351',
    label: 'Bonificación Extraordinaria Temporal – Ley 29351',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'bep_ley_29351',
    label: 'Bonificación Extraordinaria Proporcional – Ley 29351 (LBS)',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'cts_904',
    label: 'CTS 904',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'sumagraciosa',
    label: 'SUMA GRACIOSA',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'canasta',
    label: 'CANASTA DE NAVIDAD O SIMILARES',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'prestamototal',
    label: 'Total Prestamos',
    sortable: false,
    class: COLUMN_CLASS,
    position: 4
  },
  {
    key: 'total_income',
    label: 'INGRESOS TOTALES AFECTOS (AFP-ONP-ESSALUD)',
    sortable: false,
    class: COLUMN_CLASS,
    position: 5
  },
  {
    key: 'contribution',
    label: 'FONDO 608',
    sortable: false,
    class: COLUMN_CLASS,
    position: 5
  },
  {
    key: 'insurance_premium',
    label: 'PRIMA SEG. 606',
    sortable: false,
    class: COLUMN_CLASS,
    position: 5
  },
  {
    key: 'flow',
    label: 'COM. VARIABLE 601',
    sortable: false,
    class: COLUMN_CLASS,
    position: 5
  },
  {
    key: 'mixed',
    label: 'MIXTA',
    sortable: false,
    class: COLUMN_CLASS,
    position: 5
  },
  {
    key: 'prestamos',
    label: 'DESCUENTO PRESTAMOS ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 5
  },
  {
    key: 'total_discount',
    label: 'Total descuento',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'total_to_pay',
    label: 'NETO A RECIBIR ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'quincena1',
    label: '1ra QUINCENA ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'quincena2',
    label: '2da  QUINCENA ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'liquidacion',
    label: 'Liquidacion y Gratificaciones',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'cts',
    label: 'Neto a Recibir (FINAL)',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
 /* {
    key: 'adelantos',
    label: 'ADELANTOS ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'diferencia',
    label: 'DIFERENCIA ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  }, */
  {
    key: 'segregular',
    label: 'SEG. REGULAR ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'eps675',
    label: 'EPS (6.75%) ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'eps225',
    label: 'EPS (2.25%) ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'sctr_salud',
    label: 'SCTR SALUD ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'sctr_pension',
    label: 'SCTR PENSIÓN ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  },
  {
    key: 'seguro_vida_ley',
    label: 'SEGURO VIDA LEY ',
    sortable: false,
    class: COLUMN_CLASS,
    position: 6
  }
]
